import * as types from "../types";
import { funcClearValError } from "./UserAction";

export const appNavigateTo = (nextPage) => (dispatch) => {
    try {
      dispatch(funcClearValError(""));
      dispatch({
        type: types.APP_NAVIGATE_TO,
        payload: nextPage,
      });
   
    } catch (err) {
      console.log(err)
    }
  };